import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-servicesoptions-excluded-popup",
  templateUrl: "./servicesoptions-excluded-popup.component.html",
  styles: [],
})
export class ServicesoptionsExcludedPopupComponent implements OnInit {
  constructor(public dialogRef: NgbActiveModal) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close({ success: false });
  }
}
